import React from 'react'
import { useDrag } from 'react-dnd'
import styled, { css } from 'styled-components'
import Task, { ITaskProps } from 'components/taskManager/Task'
import { useHasUserTag } from '@centra/centra-ui'

const StyledDraggableTask = styled.div<{ isDragging: boolean }>`
  ${({ isDragging }) => css`
    transition: 0.3s;
    opacity: ${isDragging ? 0.7 : 1};

    &:hover {
      z-index: 1;
    }
  `}
`

const DraggableTask = (props: ITaskProps) => {
  const { task, onActivate } = props
  const isAccountManager = useHasUserTag(['role.account-manager'])

  const [collectedProps, drag] = useDrag({
    type: 'card',
    item: task,
    canDrag: isAccountManager,
    end: (item, monitor) => {
      return {
        test: 1,
        didDrop: monitor.didDrop(),
      }
    },
    collect: monitor => {
      return {
        isDragging: monitor.isDragging(),
      }
    },
  })

  return (
    <StyledDraggableTask isDragging={collectedProps.isDragging} ref={drag}>
      <Task key={task.id} task={{ ...task }} adminView onActivate={onActivate} />
    </StyledDraggableTask>
  )
}

export default DraggableTask
